'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _TargetDateSeriesGradeDescription = require('./TargetDateSeriesGradeDescription.css');

var _TargetDateSeriesGradeDescription2 = _interopRequireDefault(_TargetDateSeriesGradeDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * Displays the description of the grade earned by a target date series for
 * one of the issues.
 *
 * Depending on which of the issues is selected, it will show different:
 *
 * - background image
 * - icon
 * - grade label
 * - methodology link
 * - "the issues" link
 *
 * Depending on which of the target date series is selected; as well as which
 * of the issues is selected; it will show different:
 *
 * - headline
 * - grade
 * - sentence describing the grade
 *
 */
var TargetDateSeriesGradeDescription = (_dec = (0, _reactCssModules2.default)(_TargetDateSeriesGradeDescription2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesGradeDescription, _Component);

  function TargetDateSeriesGradeDescription(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesGradeDescription);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesGradeDescription.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesGradeDescription)).call(this, props));

    _this.state = _this.getGradeDescriptionState(props.iyvCode, props.targetDateSeries);
    return _this;
  }

  (0, _createClass3.default)(TargetDateSeriesGradeDescription, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState(this.getGradeDescriptionState(props.iyvCode, props.targetDateSeries));
    }
  }, {
    key: 'getGradeDescriptionState',
    value: function getGradeDescriptionState(iyvCode, targetDateSeries) {
      var gradeHeadlineDescription = {};
      switch (iyvCode) {
        case 'fff':
          gradeHeadlineDescription = this.getFffGradeDescr(targetDateSeries);
          break;
        case 'ffb':
          gradeHeadlineDescription = this.getFfbGradeDescr(targetDateSeries);
          break;
        case 'ffi':
          gradeHeadlineDescription = this.getFfiGradeDescr(targetDateSeries);
          break;
        case 'dff':
          gradeHeadlineDescription = this.getDffGradeDescr(targetDateSeries);
          break;
        case 'gef':
          gradeHeadlineDescription = this.getGefGradeDescr(targetDateSeries);
          break;
        case 'gff':
          gradeHeadlineDescription = this.getGffGradeDescr(targetDateSeries);
          break;
        case 'pff':
          gradeHeadlineDescription = this.getPffGradeDescr(targetDateSeries);
          break;
        case 'wff':
          gradeHeadlineDescription = this.getWffGradeDescr(targetDateSeries);
          break;
        case 'tff':
          gradeHeadlineDescription = this.getTffGradeDescr(targetDateSeries);
          break;
      }

      // get the grade as int and letter
      var gradeField = {
        fff: 'grade_fossil',
        ffb: 'grade_fossil_bank',
        ffi: 'grade_fossil_insure',
        dff: 'grade_deforestation',
        gef: 'grade_gender_equality',
        gff: 'grade_guns',
        pff: 'grade_prison_industrial_complex',
        wff: 'grade_military',
        tff: 'grade_tobacco'
      }[iyvCode || null];

      var gradeAsInt = targetDateSeries[gradeField];

      // get the label for the grade
      var issueLabel = {
        fff: 'Fossil fuel',
        ffb: 'Fossil fuel finance',
        ffi: 'Fossil fuel insurance',
        dff: 'Deforestation',
        gef: 'Gender equality',
        gff: 'Civilian firearms',
        pff: 'Prison industrial complex',
        wff: 'Military weapons',
        tff: 'Tobacco'
      }[iyvCode] || null;

      // get the text for the methodology link
      var methodologyLinkText = {
        fff: 'How we grade funds on fossil fuel investments',
        ffb: 'How we grade funds on investments in fossil fuel finance',
        ffi: 'How we grade funds on investments in fossil fuel insurance',
        dff: 'How we grade funds on deforestation-risk investments',
        gef: 'How we grade funds on gender equality',
        gff: 'How we grade funds on civilian firearms investments',
        pff: 'How we grade funds on prison industrial complex investments',
        wff: 'How we grade funds on military weapons investments',
        tff: 'How we grade funds on tobacco investments'
      }[iyvCode] || null;

      var methodologyNavId = {
        fff: 'fossil-fuel-grade',
        ffb: 'fossil-finance-grade',
        ffi: 'fossil-insurance-grade',
        dff: 'deforestation-grade',
        gef: 'gender-equality-grade',
        gff: 'civilian-firearms-grade',
        pff: 'prison-industrial-complex-grade',
        wff: 'military-weapons-grade',
        tff: 'tobacco-grade'
      }[iyvCode] || null;

      return {
        iyvCode: iyvCode,
        headline: gradeHeadlineDescription.headline,
        descriptionSentence: gradeHeadlineDescription.descriptionSentence,
        gradeAsInt: gradeAsInt,
        issueLabel: issueLabel,
        methodologyLinkText: methodologyLinkText,
        methodologyNavId: methodologyNavId
      };
    }

    /**
     * SITE-SPECIFIC FUNCTIONS
     */

  }, {
    key: 'getFffGradeDescr',
    value: function getFffGradeDescr(targetDateSeries) {
      // targetDateSeries[cnfg.grade]
      var val = _format2.default.perc(targetDateSeries.ff_all_weight);
      var headline = _react2.default.createElement(
        'span',
        null,
        'The ',
        targetDateSeries.strategy_name,
        ' is ',
        _react2.default.createElement(
          'span',
          { styleName: 'score-color-' + targetDateSeries.grade_fossil },
          val
        ),
        ' invested in fossil fuels.'
      );
      var descriptionSentence = {
        1: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            '0%'
          ),
          ' fossil fuel exposure is assigned a grade of A.'
        ),
        2: _react2.default.createElement(
          'span',
          null,
          'Fossil fuel exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val
          ),
          '  places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'B\xA0tier'
          ),
          ', between 0% and 3% exposure.'
        ),
        3: _react2.default.createElement(
          'span',
          null,
          'Fossil fuel exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val
          ),
          '  places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'C\xA0tier'
          ),
          ', between 3% and 5.5% exposure.'
        ),
        4: _react2.default.createElement(
          'span',
          null,
          'Fossil fuel exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val
          ),
          '  places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'D\xA0tier'
          ),
          ', between 5.5% and 9% exposure.'
        ),
        5: _react2.default.createElement(
          'span',
          null,
          'Fossil fuel exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val
          ),
          '  places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'F\xA0tier'
          ),
          ', between 9% and 100% exposure.'
        )
      }[targetDateSeries.grade_fossil];
      if (!descriptionSentence) {
        return null;
      }
      return {
        headline: headline,
        descriptionSentence: descriptionSentence
      };
    }
  }, {
    key: 'getFfbGradeDescr',
    value: function getFfbGradeDescr(targetDateSeries) {
      var _score = _format2.default.number(targetDateSeries.fossil_bank_score, false, false, 1);
      var headline = _react2.default.createElement(
        'span',
        null,
        'The ',
        targetDateSeries.strategy_name,
        ' has a score of ',
        _react2.default.createElement(
          'span',
          { styleName: 'score-color-' + targetDateSeries.grade_fossil_bank },
          _score
        ),
        ' for fossil fuel finance.'
      );
      var descriptionSentence = null;
      switch (targetDateSeries.grade_fossil_bank) {
        case 1:
          descriptionSentence = 'No holdings flagged by our fossil fuel finance screen.';
          break;
        case 2:
          descriptionSentence = _react2.default.createElement(
            'span',
            null,
            'Fossil fuel finance score of ',
            _react2.default.createElement(
              'b',
              null,
              _score
            ),
            ' places the fund in the ',
            _react2.default.createElement(
              'b',
              null,
              'B\xA0tier'
            ),
            ', between 0 and 5 points.'
          );
          break;
        case 3:
          descriptionSentence = _react2.default.createElement(
            'span',
            null,
            'Fossil fuel finance score of ',
            _react2.default.createElement(
              'b',
              null,
              _score
            ),
            ' places the fund in the ',
            _react2.default.createElement(
              'b',
              null,
              'C\xA0tier'
            ),
            ', between 5 and 15 points.'
          );
          break;
        case 4:
          descriptionSentence = _react2.default.createElement(
            'span',
            null,
            'Fossil fuel finance score of ',
            _react2.default.createElement(
              'b',
              null,
              _score
            ),
            ' places the fund in the ',
            _react2.default.createElement(
              'b',
              null,
              'D\xA0tier'
            ),
            ', between 15 and 25 points.'
          );
          break;
        case 5:
          descriptionSentence = _react2.default.createElement(
            'span',
            null,
            'Fossil fuel finance score of ',
            _react2.default.createElement(
              'b',
              null,
              _score
            ),
            ' places the fund in the ',
            _react2.default.createElement(
              'b',
              null,
              'F\xA0tier'
            ),
            ', above 25 points.'
          );
          break;
      }
      if (!descriptionSentence) {
        return null;
      }
      return {
        headline: headline,
        descriptionSentence: descriptionSentence
      };
    }
  }, {
    key: 'getFfiGradeDescr',
    value: function getFfiGradeDescr(targetDateSeries) {
      var _score = _format2.default.number(targetDateSeries.fossil_insure_score, false, false, 1);
      var headline = _react2.default.createElement(
        'span',
        null,
        'The ',
        targetDateSeries.strategy_name,
        ' has a score of ',
        _react2.default.createElement(
          'span',
          { styleName: 'score-color-' + targetDateSeries.grade_fossil_insure },
          _score
        ),
        ' for fossil fuel insurance.'
      );
      var descriptionSentence = null;
      switch (targetDateSeries.grade_fossil_insure) {
        case 1:
          descriptionSentence = _react2.default.createElement(
            'span',
            null,
            'Fossil fuel insurance score of ',
            _react2.default.createElement(
              'b',
              null,
              _score
            ),
            ' places the fund in the ',
            _react2.default.createElement(
              'b',
              null,
              'A\xA0tier'
            ),
            '.'
          );
          break;
        case 2:
          descriptionSentence = _react2.default.createElement(
            'span',
            null,
            'Fossil fuel insurance score of ',
            _react2.default.createElement(
              'b',
              null,
              _score
            ),
            ' places the fund in the ',
            _react2.default.createElement(
              'b',
              null,
              'B\xA0tier'
            ),
            ', between 0 and 5 points.'
          );
          break;
        case 3:
          descriptionSentence = _react2.default.createElement(
            'span',
            null,
            'Fossil fuel insurance score of ',
            _react2.default.createElement(
              'b',
              null,
              _score
            ),
            ' places the fund in the ',
            _react2.default.createElement(
              'b',
              null,
              'C\xA0tier'
            ),
            ', between 5 and 15 points.'
          );
          break;
        case 4:
          descriptionSentence = _react2.default.createElement(
            'span',
            null,
            'Fossil fuel insurance score of ',
            _react2.default.createElement(
              'b',
              null,
              _score
            ),
            ' places the fund in the ',
            _react2.default.createElement(
              'b',
              null,
              'D\xA0tier'
            ),
            ', between 15 and 25 points.'
          );
          break;
        case 5:
          descriptionSentence = _react2.default.createElement(
            'span',
            null,
            'Fossil fuel insuranceg score of ',
            _react2.default.createElement(
              'b',
              null,
              _score
            ),
            ' places the fund in the ',
            _react2.default.createElement(
              'b',
              null,
              'F\xA0tier'
            ),
            ', above 25 points.'
          );
          break;
      }
      if (!descriptionSentence) {
        return null;
      }
      return {
        headline: headline,
        descriptionSentence: descriptionSentence
      };
    }
  }, {
    key: 'getDffGradeDescr',
    value: function getDffGradeDescr(targetDateSeries) {
      var val_p = _format2.default.perc(targetDateSeries.df_p_weight);
      var val_all = _format2.default.perc(targetDateSeries.df_all_weight);
      var headline = _react2.default.createElement(
        'span',
        null,
        'The ',
        targetDateSeries.strategy_name,
        ' is ',
        _react2.default.createElement(
          'span',
          { styleName: 'score-color-' + targetDateSeries.grade_deforestation },
          val_p
        ),
        ' invested in deforestation-risk agribusiness.'
      );
      var descriptionSentence = {
        1: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            '0%'
          ),
          ' deforestation-risk screen exposure is assigned a grade of A.'
        ),
        2: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            '0%'
          ),
          ' deforestation-risk agribusiness exposure. Deforestation-risk finance/consumer brands exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_all
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'B\xA0tier'
          ),
          '.'
        ),
        3: _react2.default.createElement(
          'span',
          null,
          'Deforestation-risk agribusiness exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_p
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'C\xA0tier'
          ),
          ', between 0% and 0.5% exposure.'
        ),
        4: _react2.default.createElement(
          'span',
          null,
          'Deforestation-risk agribusiness exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_p
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'D\xA0tier'
          ),
          ', between 0.5% and 1.5% exposure.'
        ),
        5: _react2.default.createElement(
          'span',
          null,
          'Deforestation-risk agribusiness exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_p
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'F\xA0tier'
          ),
          ', between 1.5% and 100% exposure.'
        )
      }[targetDateSeries.grade_deforestation];
      if (!descriptionSentence) {
        return null;
      }
      return {
        headline: headline,
        descriptionSentence: descriptionSentence
      };
    }
  }, {
    key: 'getGefGradeDescr',
    value: function getGefGradeDescr(targetDateSeries) {
      var val_score = Math.round(targetDateSeries.gef_score);
      var headline = _react2.default.createElement(
        'span',
        null,
        'The ',
        targetDateSeries.strategy_name,
        ' has a gender equality score of ',
        _react2.default.createElement(
          'span',
          { styleName: 'score-color-' + targetDateSeries.grade_gender_equality },
          val_score
        ),
        ' out of 100 points.'
      );
      var descriptionSentence = {
        1: _react2.default.createElement(
          'span',
          null,
          'Gender equality score of ',
          _react2.default.createElement(
            'b',
            null,
            val_score,
            ' out of 100 points'
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'A\xA0tier'
          ),
          ', the top 20% of the Allocation Funds group.'
        ),
        2: _react2.default.createElement(
          'span',
          null,
          'Gender equality score of ',
          _react2.default.createElement(
            'b',
            null,
            val_score,
            ' out of 100 points'
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'B\xA0tier'
          ),
          ', the second 20% of the Allocation Funds group.'
        ),
        3: _react2.default.createElement(
          'span',
          null,
          'Gender equality score of ',
          _react2.default.createElement(
            'b',
            null,
            val_score,
            ' out of 100 points'
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'C\xA0tier'
          ),
          ', the middle 20% of the Allocation Funds group.'
        ),
        4: _react2.default.createElement(
          'span',
          null,
          'Gender equality score of ',
          _react2.default.createElement(
            'b',
            null,
            val_score,
            ' out of 100 points'
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'D\xA0tier'
          ),
          ', the second-last 20% of the Allocation Funds group.'
        ),
        5: _react2.default.createElement(
          'span',
          null,
          'Gender equality score of ',
          _react2.default.createElement(
            'b',
            null,
            val_score,
            ' out of 100 points'
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'F\xA0tier'
          ),
          ', the bottom 20% of the Allocation Funds group.'
        )
      }[targetDateSeries.grade_gender_equality];
      if (!descriptionSentence) {
        return null;
      }
      return {
        headline: headline,
        descriptionSentence: descriptionSentence
      };
    }
  }, {
    key: 'getGffGradeDescr',
    value: function getGffGradeDescr(targetDateSeries) {
      var val_high = _format2.default.perc(targetDateSeries.wff_gun_manufacturers_weight);
      var val_all = _format2.default.perc(targetDateSeries.wff_civ_weight);
      var headline = _react2.default.createElement(
        'span',
        null,
        'The ',
        targetDateSeries.strategy_name,
        ' has ',
        _react2.default.createElement(
          'span',
          { styleName: 'score-color-' + targetDateSeries.grade_guns },
          val_high
        ),
        ' exposure to civilian firearm manufacturers.'
      );
      var descriptionSentence = {
        1: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            '0%'
          ),
          ' civilian firearms screen exposure places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'A\xA0tier'
          ),
          '.'
        ),
        2: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            '0%'
          ),
          ' gun manufacturers exposure. Gun retailers exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_all
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'B\xA0tier'
          ),
          '.'
        ),
        3: _react2.default.createElement(
          'span',
          null,
          'Gun manufacturers exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_high
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'C\xA0tier'
          ),
          ', between 0% and 0.1% exposure.'
        ),
        4: _react2.default.createElement(
          'span',
          null,
          'Gun manufacturers exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_high
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'D\xA0tier'
          ),
          ', between 0.1% and 0.4% exposure.'
        ),
        5: _react2.default.createElement(
          'span',
          null,
          'Gun manufacturers exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_high
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'F\xA0tier'
          ),
          ', between 0.4% and 100% exposure.'
        )
      }[targetDateSeries.grade_guns];
      if (!descriptionSentence) {
        return null;
      }
      return {
        headline: headline,
        descriptionSentence: descriptionSentence
      };
    }
  }, {
    key: 'getPffGradeDescr',
    value: function getPffGradeDescr(targetDateSeries) {
      var val_extreme = _format2.default.perc(targetDateSeries.pff_extreme_weight);
      var val_high = _format2.default.perc(targetDateSeries.pff_high_weight);
      var val_all = _format2.default.perc(targetDateSeries.pff_all_weight);
      var headline = _react2.default.createElement(
        'span',
        null,
        'The ',
        targetDateSeries.strategy_name,
        ' has ',
        _react2.default.createElement(
          'span',
          { styleName: 'score-color-' + targetDateSeries.grade_prison_industrial_complex },
          val_high
        ),
        ' exposure to the high-risk prison industrial complex screen.'
      );
      var descriptionSentence = {
        1: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            '0%'
          ),
          ' prison industrial complex screen exposure places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'A\xA0tier'
          ),
          '.'
        ),
        2: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            '0%'
          ),
          ' exposure to higher-risk prison industrial complex screen. Other prison industry/border industry exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_all
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'B\xA0tier'
          ),
          '.'
        ),
        3: _react2.default.createElement(
          'span',
          null,
          'Exposure to higher-risk prison industrial complex screen of ',
          _react2.default.createElement(
            'b',
            null,
            val_high
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'C\xA0tier'
          ),
          ', between 0% and 1% exposure.'
        ),
        4: _react2.default.createElement(
          'span',
          null,
          'Exposure to higher-risk prison industrial complex screen of ',
          _react2.default.createElement(
            'b',
            null,
            val_high
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'D\xA0tier'
          ),
          ', between 1% and 2% exposure.'
        ),
        5: _react2.default.createElement(
          'span',
          null,
          'Exposure to higher-risk prison industrial complex screen of ',
          _react2.default.createElement(
            'b',
            null,
            val_high
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'F\xA0tier'
          ),
          ', between 2% and 100% exposure.'
        )
      }[targetDateSeries.grade_prison_industrial_complex];
      if (targetDateSeries.pff_extreme_weight > 0) {
        descriptionSentence = _react2.default.createElement(
          'span',
          null,
          'Exposure to private prison operators of ',
          _react2.default.createElement(
            'b',
            null,
            val_extreme
          ),
          '. Any exposure to private prison operators places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'F\xA0tier'
          ),
          '.'
        );
      }
      if (!descriptionSentence) {
        return null;
      }
      return {
        headline: headline,
        descriptionSentence: descriptionSentence
      };
    }
  }, {
    key: 'getWffGradeDescr',
    value: function getWffGradeDescr(targetDateSeries) {
      // const val_controversial = format.perc(targetDateSeries.wff_cluster_munitions_weight)
      // const val_nuclear = format.perc(targetDateSeries.wff_nuclear_weapons_weight)
      var val_all = _format2.default.perc(targetDateSeries.wff_mil_weight);
      var headline = _react2.default.createElement(
        'span',
        null,
        'The ',
        targetDateSeries.strategy_name,
        ' has ',
        _react2.default.createElement(
          'span',
          { styleName: 'score-color-' + targetDateSeries.grade_military },
          val_all
        ),
        ' exposure to arms manufacturers and military contractors.'
      );
      var descriptionSentence = {
        1: _react2.default.createElement(
          'span',
          null,
          'No holdings flagged for our military weapon screens. Assigned a grade of A.'
        ),
        2: _react2.default.createElement(
          'span',
          null,
          'Fund has no investments in nuclear weapons or controversial weapons, but is invested in military contractors, below the threshold of 2.5%. Assigned a grade of B.'
        ),
        3: _react2.default.createElement(
          'span',
          null,
          'Fund has investments in nuclear weapons and/or controversial weapons, and overall military contractors exposure is below the threshold of 2.5%. Assigned a grade of C.'
        ),
        4: _react2.default.createElement(
          'span',
          null,
          'Fund is invested in military contractors above the threshold of 2.5% and below the threshold of 4%. Assigned a grade of D.'
        ),
        5: _react2.default.createElement(
          'span',
          null,
          'Fund is invested in military contractors above the threshold of 4%. Assigned a grade of F.'
        )
      }[targetDateSeries.grade_military];
      if (!descriptionSentence) {
        return null;
      }
      // let descriptionSentence = {
      //   1: (<span><b>0%</b> military weapons screen exposure places the fund in the <b>A&nbsp;tier</b>.</span>),
      //   2: (<span>Military weapons screen exposure of <b>{val_all}</b> places the fund in the <b>B&nbsp;tier</b>, between 0% and 1% exposure.</span>),
      //   3: (<span>Military weapons screen exposure of <b>{val_all}</b> places the fund in the <b>C&nbsp;tier</b>, between 1% and 2% exposure.</span>),
      //   4: (<span>Military weapons screen exposure of <b>{val_all}</b> places the fund in the <b>D&nbsp;tier</b>, between 2% and 3% exposure.</span>),
      //   5: (<span>Military weapons screen exposure of <b>{val_all}</b> places the fund in the <b>F&nbsp;tier</b>, between 3% and 100% exposure.</span>)
      // }[targetDateSeries.grade_military]
      // if (!descriptionSentence) { return null }
      // if (targetDateSeries.wff_cluster_munitions_weight > 0) {
      //   descriptionSentence = (<span>Exposure to cluster munitions screen of <b>{val_extreme}</b>. Any exposure to cluster munitions screen places the fund in the <b>F&nbsp;tier</b>.</span>)
      // }
      return {
        headline: headline,
        descriptionSentence: descriptionSentence
      };
    }
  }, {
    key: 'getTffGradeDescr',
    value: function getTffGradeDescr(targetDateSeries) {
      var val_high = _format2.default.perc(targetDateSeries.t_weight);
      var val_all = _format2.default.perc(targetDateSeries.t_all_weight);
      var headline = _react2.default.createElement(
        'span',
        null,
        'The ',
        targetDateSeries.strategy_name,
        ' has ',
        _react2.default.createElement(
          'span',
          { styleName: 'score-color-' + targetDateSeries.grade_tobacco },
          val_high
        ),
        ' exposure to tobacco producers.'
      );
      var descriptionSentence = {
        1: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            '0%'
          ),
          ' tobacco screen exposure places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'A\xA0tier'
          ),
          '.'
        ),
        2: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'b',
            null,
            '0%'
          ),
          ' tobacco producers exposure. Tobacco-promoting entertainment studios exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_all
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'B\xA0tier'
          ),
          '.'
        ),
        3: _react2.default.createElement(
          'span',
          null,
          'Tobacco producers exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_high
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'C\xA0tier'
          ),
          ', between 0% and 0.5% exposure.'
        ),
        4: _react2.default.createElement(
          'span',
          null,
          'Tobacco producers exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_high
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'D\xA0tier'
          ),
          ', between 0.5% and 1.2% exposure.'
        ),
        5: _react2.default.createElement(
          'span',
          null,
          'Tobacco producers exposure of ',
          _react2.default.createElement(
            'b',
            null,
            val_high
          ),
          ' places the fund in the ',
          _react2.default.createElement(
            'b',
            null,
            'F\xA0tier'
          ),
          ', between 1.2% and 100% exposure.'
        )
      }[targetDateSeries.grade_tobacco];
      if (!descriptionSentence) {
        return null;
      }
      return {
        headline: headline,
        descriptionSentence: descriptionSentence
      };
    }

    //

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          iyvCode = _state.iyvCode,
          headline = _state.headline,
          descriptionSentence = _state.descriptionSentence,
          gradeAsInt = _state.gradeAsInt,
          issueLabel = _state.issueLabel,
          methodologyLinkText = _state.methodologyLinkText,
          methodologyNavId = _state.methodologyNavId;

      // get the icon

      var iconWhite = {
        fff: require('../../../static/images/icons/fff-icon-white.svg'),
        ffb: require('../../../static/images/icons/ffb-icon-white.svg'),
        ffi: require('../../../static/images/icons/ffi-icon-white.svg'),
        dff: require('../../../static/images/icons/dff-icon-white.svg'),
        gef: require('../../../static/images/icons/gef-icon-white.svg'),
        gff: require('../../../static/images/icons/gff-icon-white.svg'),
        pff: require('../../../static/images/icons/pff-icon-white.svg'),
        wff: require('../../../static/images/icons/wff-icon-white.svg'),
        tff: require('../../../static/images/icons/tff-icon-white.svg')
      }[iyvCode] || null;

      //
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'grade-descrp-flex' },
        _react2.default.createElement(
          'div',
          { styleName: 'grade-descrp-flex-cell' },
          _react2.default.createElement(
            'div',
            { styleName: 'site-img img-' + iyvCode },
            _react2.default.createElement(
              'div',
              { styleName: 'site-img-gray' },
              _react2.default.createElement(
                'h2',
                { styleName: 'site-img-headline' },
                iconWhite ? _react2.default.createElement(
                  'div',
                  { styleName: 'site-img-icon-bbl' },
                  _react2.default.createElement('img', {
                    styleName: 'site-img-icon',
                    src: iconWhite,
                    alt: issueLabel + ' grade'
                  })
                ) : null,
                headline
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'grade-descrp-flex-cell' },
          _react2.default.createElement(
            'div',
            { styleName: 'scorecard-header-grade-flex' },
            _react2.default.createElement(
              'div',
              { styleName: 'icon-label-flex' },
              _react2.default.createElement(
                'h2',
                { styleName: 'grade-descrp-grade-label' },
                issueLabel,
                ' grade'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'scorecard-header-grade' },
              _react2.default.createElement(_components.Grade, { grade: gradeAsInt, block: true })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'grade-descrp' },
            descriptionSentence
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'methodology-link' },
            _react2.default.createElement(
              'span',
              null,
              'Methodology'
            ),
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.methodology + '#' + methodologyNavId,
                title: 'How it works'
              },
              methodologyLinkText
            )
          )
        )
      );
    }
  }]);
  return TargetDateSeriesGradeDescription;
}(_react.Component), _class2.propTypes = {
  // three letters, fff/dff/gef/gff/pff/wff/tff
  iyvCode: _react.PropTypes.string.isRequired,
  // the target date series object
  targetDateSeries: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesGradeDescription;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesGradeDescription/TargetDateSeriesGradeDescription.js
// module id = 1449
// module chunks = 0